import { Storage } from 'aws-amplify';


export const downloadS3Object =async(key)=>{
    try {
        const SignedUrl = await Storage.get(key, {
            level: 'public' ,
            download: true, // defaults to false
            expires: 300, // validity of the URL, in seconds. defaults to 900 (15 minutes)
            
        });
        downloadBlob(SignedUrl.Body,key.split('/').at(-1))
    } catch (error) {
        console.log(error)
    }
}
export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    const clickHandler = () => {
        setTimeout(() => {
            URL.revokeObjectURL(url);
            a.removeEventListener('click', clickHandler);
        }, 150);
    };
    a.addEventListener('click', clickHandler, false);
    a.click();
    return a;
}